// Recovered compiled webpack factory 47670. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      formatUrl: function () {
        return o;
      },
      formatWithValidation: function () {
        return s;
      },
      urlObjectKeys: function () {
        return i;
      },
    }));
  let n = r(49417)._(r(33078)),
    a = /https?|ftp|gopher|file/;
  function o(e) {
    let { auth: t, hostname: r } = e,
      o = e.protocol || "",
      i = e.pathname || "",
      s = e.hash || "",
      l = e.query || "",
      u = !1;
    ((t = t ? encodeURIComponent(t).replace(/%3A/i, ":") + "@" : ""),
      e.host
        ? (u = t + e.host)
        : r && ((u = t + (~r.indexOf(":") ? "[" + r + "]" : r)), e.port && (u += ":" + e.port)),
      l && "object" == typeof l && (l = String(n.urlQueryToSearchParams(l))));
    let c = e.search || (l && "?" + l) || "";
    return (
      o && !o.endsWith(":") && (o += ":"),
      e.slashes || ((!o || a.test(o)) && !1 !== u)
        ? ((u = "//" + (u || "")), i && "/" !== i[0] && (i = "/" + i))
        : u || (u = ""),
      s && "#" !== s[0] && (s = "#" + s),
      c && "?" !== c[0] && (c = "?" + c),
      "" + o + u + (i = i.replace(/[?#]/g, encodeURIComponent)) + (c = c.replace("#", "%23")) + s
    );
  }
  let i = [
    "auth",
    "hash",
    "host",
    "hostname",
    "href",
    "path",
    "pathname",
    "port",
    "protocol",
    "query",
    "search",
    "slashes",
  ];
  function s(e) {
    return o(e);
  }
}
